function initImageSliderSections() {
  document.querySelectorAll('[data-image-slider-section]').forEach(function (el) {
    if (typeof Swiper === 'undefined') return;
    if (el.dataset.imageSliderInitialized === 'true') return;
    el.dataset.imageSliderInitialized = 'true';

    // 'auto'면 슬라이드 폭을 내용(이미지) 크기가 정한다. 기존 섹션은 숫자만 넘기므로 동작 그대로.
    var rawMobile = el.dataset.slidesMobile;
    var rawDesktop = el.dataset.slidesDesktop;
    var slidesMobile = rawMobile === 'auto' ? 'auto' : (parseFloat(rawMobile) || 1.5);
    var slidesDesktop = rawDesktop === 'auto' ? 'auto' : (parseFloat(rawDesktop) || 3);
    var slideGap = parseInt(el.dataset.slideGap, 10) || 0;
    // data-slide-gap-mobile이 없으면 PC 간격을 그대로 사용 → 기존 섹션 동작 그대로
    var slideGapMobile = parseInt(el.dataset.slideGapMobile, 10);
    if (isNaN(slideGapMobile)) slideGapMobile = slideGap;
    var scrollbarEl = el.querySelector('.swiper-scrollbar');
    var loop = el.dataset.loop === 'true';
    var autoplay = el.dataset.autoplay === 'true';
    var autoplaySpeed = parseFloat(el.dataset.autoplaySpeed) || 3;
    var autoplayReverse = el.dataset.autoplayDirection === 'right';
    // 'step'이면 한 장씩 멈췄다가 넘어간다. 속성이 없는 기존 마크업은 'flow'(마키)로 동작한다.
    var autoplayStep = el.dataset.autoplayMode === 'step';
    var stepInterval = parseFloat(el.dataset.stepInterval) || 2.5;
    var stepDuration = parseFloat(el.dataset.stepDuration) || 1.1;
    // 슬라이드를 화면 가운데에 맞춰 멈춘다. 속성이 없는 기존 마크업은 왼쪽 정렬 그대로다.
    var centeredDesktop = el.dataset.centeredDesktop === 'true';
    var centeredMobile = el.dataset.centeredMobile === 'true';
    var useLoop = loop || autoplay;
    var wrapper = el.querySelector('.swiper-wrapper');
    var slides = wrapper ? Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide')) : [];

    if (slides.length < 2) return;

    if (useLoop && wrapper) {
      // 'auto'는 숫자가 없으므로 복제 기준을 3장으로 잡는다
      var spvForClone = Math.max(
        typeof slidesMobile === 'number' ? slidesMobile : 3,
        typeof slidesDesktop === 'number' ? slidesDesktop : 3
      );
      var minSlidesNeeded = Math.ceil(spvForClone * 3);
      var MAX_SLIDES = 60;

      // 원본 세트 단위로만 복제한다. 세트 중간에서 멈추면 루프 경계에서 같은 이미지가 연달아 붙는다.
      // (예: 원본 4장을 9장까지 채우면 1234 1234 1 이 되어, 루프가 돌 때 1 다음에 다시 1 이 온다)
      var slideCount = function () {
        return wrapper.querySelectorAll('.swiper-slide').length;
      };
      var appendSet = function () {
        for (var i = 0; i < slides.length; i++) {
          wrapper.appendChild(slides[i].cloneNode(true));
        }
      };

      while (slideCount() < minSlidesNeeded && slideCount() + slides.length <= MAX_SLIDES) {
        appendSet();
      }

      // 슬라이드가 작아 전체 폭이 화면보다 짧으면 스크롤할 것이 없어 Swiper가 잠기고
      // 자동 슬라이드가 멈춘 것처럼 보인다. 실제 폭을 재서 화면의 2배가 될 때까지 더 복제한다.
      // (슬라이드 폭이 'auto'라 미리 계산할 수 없는 경우를 대비한 안전장치)
      var containerWidth = el.clientWidth;
      var rounds = 0;
      while (
        containerWidth > 0 &&
        wrapper.scrollWidth > 0 &&
        wrapper.scrollWidth < containerWidth * 2 &&
        slideCount() + slides.length <= MAX_SLIDES &&
        rounds < 20
      ) {
        appendSet();
        rounds++;
      }
    }

    var config = {
      slidesPerView: slidesMobile,
      spaceBetween: slideGapMobile,
      centeredSlides: centeredMobile,
      loop: useLoop,
      threshold: 10,
      freeMode: {
        enabled: !useLoop,
        sticky: false,
        momentumBounce: true,
      },
      scrollbar: scrollbarEl ? {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      } : false,
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: slideGap,
          centeredSlides: centeredDesktop,
        },
      },
    };

    if (autoplay && autoplayStep) {
      // Swiper는 이동이 끝난 뒤부터 delay를 세므로, 간격에서 이동 시간을 빼야 설정한 간격마다 넘어간다.
      config.speed = stepDuration * 1000;
      config.autoplay = {
        delay: Math.max(0, stepInterval - stepDuration) * 1000,
        disableOnInteraction: false,
        reverseDirection: autoplayReverse,
      };
      el.classList.add('swiper-step');
    } else if (autoplay) {
      config.speed = autoplaySpeed * 1000;
      config.autoplay = {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: autoplayReverse,
      };
      el.classList.add('swiper-marquee');
    }

    var instance = new Swiper(el, config);

    // 슬라이드 폭이 'auto'이고 폭이 서로 다르면, Swiper는 루프 재배치(loopFix)를 장수 기준으로만 판단해
    // 끝에 슬라이드가 모자란 채로 wrapper가 끝에 닿는다. 이때 위치가 끝값에 고정된 상태에서 재배치 보정이
    // 들어가 화면이 한 번에 수백 px 튄다(오래 보고 있으면 확 넘어가는 현상).
    // 가장 좁은 장으로 화면을 채우는 장수만큼 미리 재배치하게 해서 끝에 닿지 않게 한다.
    if (useLoop && (slidesMobile === 'auto' || slidesDesktop === 'auto')) {
      var syncLoopAdditional = function () {
        if (!instance || instance.destroyed) return;
        var widths = (instance.slidesSizesGrid || []).filter(function (w) { return w > 0; });
        var containerWidth = instance.width || el.clientWidth;
        if (!widths.length || !(containerWidth > 0)) return;
        var gap = parseFloat(instance.params.spaceBetween) || 0;
        var need = Math.ceil(containerWidth / (Math.min.apply(null, widths) + gap));
        // 전체 장수보다 많이 요구하면 Swiper가 루프를 제대로 못 돌리므로 남는 장수 안에서만 늘린다
        instance.params.loopAdditionalSlides = Math.max(0, Math.min(need, instance.slides.length - need));
      };
      instance.on('update', syncLoopAdditional);
      instance.on('resize', syncLoopAdditional);
      instance.on('breakpoint', syncLoopAdditional);
      syncLoopAdditional();
    }

    // 흐름 모드의 speed는 '한 장을 넘기는 시간'이라, 슬라이드별 크기 지정으로 폭이 다른 장이 섞이면
    // 넓은 장만 빨리 지나간다. 다음에 지나갈 장의 폭에 비례해 speed를 바꿔 픽셀 속도를 일정하게 맞춘다.
    // Swiper autoplay는 매 이동 직전에 params.speed를 읽으므로 slideChange에서 미리 바꿔 둔다.
    // 기준은 가장 좁은 장이며, 폭이 모두 같으면 비율이 1이라 기존 동작 그대로다.
    if (autoplay && !autoplayStep && el.classList.contains('image-slider-section__swiper--sized')) {
      var baseSpeed = autoplaySpeed * 1000;
      var syncFlowSpeed = function () {
        if (!instance || instance.destroyed) return;
        var sizes = instance.slidesSizesGrid || [];
        var widths = sizes.filter(function (w) { return w > 0; });
        if (!widths.length) return;
        var gap = parseFloat(instance.params.spaceBetween) || 0;
        var index = autoplayReverse ? instance.activeIndex - 1 : instance.activeIndex;
        var width = sizes[index];
        if (!(width > 0)) return;
        var minWidth = Math.min.apply(null, widths);
        instance.params.speed = Math.round(baseSpeed * (width + gap) / (minWidth + gap));
      };
      instance.on('slideChange', syncFlowSpeed);
      instance.on('update', syncFlowSpeed);
      instance.on('breakpoint', syncFlowSpeed);
      syncFlowSpeed();
    }

    // 점 표시: 루프용으로 복제한 슬라이드는 제외하고 원본 장수만큼 점을 만든다.
    // 점 컨테이너는 슬라이더와 같은 부모 아래에 있다. 사이에 <style>이 렌더링되므로 바로 다음 형제로 찾지 않는다.
    var paginationEl = el.parentElement
      ? el.parentElement.querySelector(':scope > [data-image-slider-pagination]')
      : null;
    if (paginationEl) {
      var dotCount = slides.length;
      var dots = [];
      paginationEl.innerHTML = '';
      for (var d = 0; d < dotCount; d++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'image-slider-section__dot';
        dot.setAttribute('aria-label', (d + 1) + '번 슬라이드로 이동');
        dot.addEventListener('click', (function (index) {
          return function () {
            if (useLoop) instance.slideToLoop(index);
            else instance.slideTo(index);
          };
        })(d));
        paginationEl.appendChild(dot);
        dots.push(dot);
      }
      paginationEl.hidden = false;

      var updateDots = function () {
        if (!instance || instance.destroyed) return;
        var current = useLoop ? instance.realIndex % dotCount : instance.activeIndex;
        // 한 화면에 여러 장이 보이면 끝까지 밀어도 activeIndex가 마지막 장에 닿지 않으므로 끝이면 마지막 점을 켠다
        if (!useLoop && instance.isEnd) current = dotCount - 1;
        dots.forEach(function (item, index) {
          var active = index === current;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      };

      instance.on('slideChange', updateDots);
      instance.on('reachEnd', updateDots);
      instance.on('reachBeginning', updateDots);
      instance.on('transitionEnd', updateDots);
      updateDots();
    }

    // 슬라이드 이미지는 lazy 로딩이라 초기화 시점에 크기가 확정되지 않을 수 있다.
    // 이때 Swiper가 잘못된 크기로 계산하면 자동 슬라이드가 멈춘 것처럼 보이고,
    // 스크롤 등으로 리사이즈가 일어나야 비로소 움직인다.
    // 이미지가 로드될 때마다 크기를 다시 계산하고, 필요하면 자동 재생을 다시 시작한다.
    var refresh = function () {
      if (!instance || instance.destroyed) return;
      instance.update();
      if (autoplay && instance.autoplay && !instance.autoplay.running) {
        instance.autoplay.start();
      }
    };

    el.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', refresh, { once: true });
      img.addEventListener('error', refresh, { once: true });
    });

    if (document.readyState !== 'complete') {
      window.addEventListener('load', refresh, { once: true });
    }
  });
}

document.addEventListener('DOMContentLoaded', initImageSliderSections);

// 테마 에디터에서 섹션을 추가·수정하면 DOM이 교체되므로 다시 초기화한다.
// 이미 초기화된 요소는 dataset 플래그로 걸러진다.
document.addEventListener('shopify:section:load', initImageSliderSections);
